
import React from 'react';
import { DeepAnalysisResult } from '@/types/analysisTypes';
import { AnalysisScoresDisplay } from '../AnalysisScoresDisplay';
import { RecommendationsDisplay } from '../RecommendationsDisplay';
import { FullReportDisplay } from '../FullReportDisplay';
import { ShareabilityDisplay } from '../ShareabilityDisplay';
import { BonusInsightsDisplay } from '../BonusInsightsDisplay';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface TabContentProps {
  activeTab: string;
  pageAnalysisResult: DeepAnalysisResult;
  urlInput: string;
  handleExportRecommendations: () => void;
  errorMessage?: string | null;
}

export const TabContent: React.FC<TabContentProps> = ({
  activeTab,
  pageAnalysisResult,
  urlInput,
  handleExportRecommendations,
  errorMessage
}) => {
  if (errorMessage) {
    return (
      <div className="glass-panel rounded-xl p-6">
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Analysis Failed</AlertTitle>
          <AlertDescription>
            {errorMessage}
          </AlertDescription>
        </Alert>
        <p className="text-muted-foreground">Please check your API settings and try again.</p>
      </div>
    );
  }

  if (!pageAnalysisResult) {
    return (
      <div className="glass-panel rounded-xl p-6 flex justify-center items-center">
        <p className="text-muted-foreground">No page analysis available. Please select a page to analyze.</p>
      </div>
    );
  }

  // Removed any potential "Top Performing Pages" sections from all tab content
  switch (activeTab) {
    case 'scores':
      return <AnalysisScoresDisplay pageAnalysisResult={pageAnalysisResult} />;
    case 'recommendations':
      return (
        <RecommendationsDisplay 
          pageAnalysisResult={pageAnalysisResult}
          urlInput={urlInput}
          handleExportRecommendations={handleExportRecommendations}
        />
      );
    case 'shareability':
      return <ShareabilityDisplay pageAnalysisResult={pageAnalysisResult} />;
    case 'bonusInsights':
      return <BonusInsightsDisplay pageAnalysisResult={pageAnalysisResult} />;
    case 'fullReport':
      return <FullReportDisplay pageAnalysisResult={pageAnalysisResult} />;
    default:
      return <AnalysisScoresDisplay pageAnalysisResult={pageAnalysisResult} />;
  }
};
